<template>
  <div class="brand-overview-page">
    <fn-section
      class="show-m"
      constrained="l"
      padding-top="xs"
      padding-bottom="xs"
      background-color="sand-light"
    >
      <fn-breadcrumbs
        :nodes="page.content.breadcrumbs"
        no-underline
      />
    </fn-section>

    <fn-cms-section-loader
      v-if="page.content.content_slots.a && page.content.content_slots.a.sections"
      :sections="page.content.content_slots.a.sections"
    />

    <fn-section
      constrained="l"
      padding-top="s"
      padding-bottom="s"
      background-color="sand-light"
    >
      <fn-alpha-index-slider
        :items="sortedBrands"
        :active-item-name="Object.keys(filteredBrands)[0]"
        :show-all="showAll"
        @reset-filter="resetFilter"
        @filter-brands="filterBrands"
      />
    </fn-section>

    <fn-section
      constrained="l"
      padding-bottom="s"
      background-color="sand-light"
    >
      <div class="brands">
        <div
          v-for="(value, name, index) in filteredBrands"
          v-show="value.length > 0"
          :key="index"
          class="brand-group"
        >
          <fn-headline
            :id="'brand-group-headline-' + index"
            class="bg-title"
            type="h2"
          >
            {{ name === 'other' ? '#' : name.toUpperCase() }}
          </fn-headline>
          <fn-grid class="bg-items">
            <fn-grid-item
              v-for="(brand, index2) in value"
              :key="index2"
              static
              columns="6"
              columns-s="4"
              columns-m="3"
              class="bg-item"
            >
              <fn-link
                :id="'brand-item-' + index2"
                no-arrow
                :to="{
                  path: brand.url,
                }"
              >
                {{ brand.title }}
              </fn-link>
            </fn-grid-item>
          </fn-grid>
        </div>
      </div>
    </fn-section>

    <fn-section
      v-if="showAll"
      constrained="l"
      padding-top="s"
      padding-bottom="s"
      background-color="sand-light"
    >
      <fn-alpha-index-slider
        :items="sortedBrands"
        :active-item-name="Object.keys(filteredBrands)[0]"
        :show-all="showAll"
        @reset-filter="resetFilter"
        @filter-brands="filterBrands"
      />
    </fn-section>

    <fn-cms-section-loader
      v-if="page.content.content_slots.b && page.content.content_slots.b.sections"
      :sections="page.content.content_slots.b.sections"
    />
  </div>
</template>

<script>
import PageScroll from '@/mixins/PageScroll';
import HashLink from '@/mixins/HashLink';

export default defineComponent({
  mixins: [PageScroll, HashLink],
  props: {
    page: {
      type: Object,
      required: true,
    },
    brands: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    filter: null,
    showAll: true,
  }),
  computed: {
    filteredBrands() {
      if (this.filter && this.brands[this.filter] && this.brands[this.filter].length > 0) {
        const filteredBrands = {};
        filteredBrands[this.filter] = this.brands[this.filter];

        return filteredBrands;
      }

      return this.sortedBrands;
    },

    sortedBrands() {
      const sortedBrands = {};
      this.sortedLetters.forEach((letter) => {
        sortedBrands[letter] = this.brands[letter];
      });
      return sortedBrands;
    },

    sortedLetters() {
      if (!this.brands) {
        return [];
      }

      const sortedItems = Object.keys(this.brands).sort();

      const otherIdx = sortedItems.indexOf('other');
      if (otherIdx > -1) {
        sortedItems.splice(otherIdx, 1);
        sortedItems.unshift('other');
      }

      return sortedItems;
    },
  },
  methods: {
    filterBrands(brandGroupTitle) {
      setTimeout(() => {
        this.scrollToTop();
      }, 0);

      this.showAll = false;
      this.filter = brandGroupTitle;
    },

    resetFilter() {
      this.showAll = true;
      this.filter = null;
    },
  },
});
</script>

<style lang="scss" scoped>
.brand-overview-page {
  .brands {
    min-height: 50vh;
    .brand-group {
      margin-bottom: $space;

      :deep(.grid) {
        flex: 1 1 auto;
      }

      .bg-title {
        padding-bottom: math.div($pad, 2);
        border-bottom: 1px solid palette(grey, light);
      }

      .bg-items {
        display: flex;
      }
    }
  }
}
</style>
